import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatSearchPlaceholder } from 'modules/_shared/components/Tables/utils/formatSearchPlaceholder';

import SearchModule from 'modules/_shared/components/SearchModule';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import ShareTitlesTable from './ShareTitleTable';
import { useShareTitleListPage } from '../context/ShareTitleListPageContext';

const ShareTitleListPageBody: FC = () => {
  const { t, i18n } = useTranslate();
  const { data, actions } = useShareTitleListPage();

  const showPagination = data.shareTitles && data.shareTitleTotal > 10;

  return (
    <div className="nk-block">
      <SearchModule
        placeholder={formatSearchPlaceholder(
          [t('Number'), t('Partner'), t('Email'), t('CIF')],
          i18n
        )}
        onSearch={actions.handleSearch}
      />
      <ShareTitlesTable />

      {showPagination && (
        <TablePagination
          totalRows={data.shareTitleTotal || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default ShareTitleListPageBody;
